<template>
  <div class="container">
    <div class="title">
      <p class="words">端口使用率(%)</p>
    </div>
    <div class="val-pot">使用率：{{carouselVal}}%</div>
    <div id="chart6" ref="main6" style="width: 100%; height: 160px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea6: null,
      xData: [],
      yData: [],
      carouselVal:0,
      timerId: null, //定时器的标识
      timer:null,
    };
  },
  props: {
    regionId: "",
  },
  created() {
    this.timer = setInterval(() => {
      // setTimeout(this.getoption6Data(), 0);
    }, 1000 * 60);
  },
  destroyed() {
    clearInterval(this.timerId);
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.echartArea6 = this.$echarts.init(this.$refs.main6);
      this.getoption6Data();
    },
    // 组件6数据源 端口使用率
    getoption6Data() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getPortUsage"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data, "端口使用率");
        if (data.code == 0) {
          this.xData = data.data.keys;
          this.yData = data.data.values1;
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      var XData = this.xData;
      var YData = this.yData;
      const option = {
        // tooltip: {
        //   show:false,
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "shadow",
        //   },
        //   // position:
        //   position: ["80%", "10%"],
        // },
        grid: {
          left: "1%",
          right: "1%",
          bottom: "10%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: {
          type: "category",
          gridIndex: 0,
          data: XData,
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: 10,
          },
        },
        yAxis: {
          name: "元",
          type: "value",
          gridIndex: 0,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: function (value) {
            if (value.max <= 100) {
              return 100;
            } else if (value.max > 100 && value.max <= 200) {
              return 200;
            } else if (value.max > 200 && value.max <= 300) {
              return 300;
            }
          },
          xisLabel: {
            color: "rgb(170,170,170)",
            formatter: "{value} ",
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(135,140,147,0.8)",
            },
          },
          axisLabel: {
            formatter: function (value) {
              return value + "%";
            },
            fontSize: 10,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "30%",
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "#72B4FA" },
                { offset: 1, color: "#3E7DF2" },
              ]),
              barBorderRadius: [10, 10, 0, 0],
            },
            emphasis: {
              itemStyle: {
                color: "#44D7B6",
              },
              label: {
                // show: true,
              },
            },
            data: YData,
            zlevel: 11,
          },
        ],
      };

      this.echartArea6.setOption(option);
      let _t = -1;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        var dataLen = option.series[0].data.length;
        this.echartArea6.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: _t,
        });
        _t = (_t + 1) % dataLen;
        this.echartArea6.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: _t,
        });
        this.carouselVal = option.series[0].data[_t]
        // this.echartArea6.setOption(option);
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;
  position: relative;
  .val-pot{
    position: absolute;
    right: 20px;
    top: 12px;
    font-size: 12px;
  }
}
.title {
  width: 140px;
  height: 28px;
  line-height: 28px;
  background-image: url("../../assets/title-bg.png");
  background-size: 100% 100%;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #00ecfc;
  position: relative;
  .words {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 280px;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/views/bicycle-system/option6.vue